import { useState, useMemo } from 'react'
import { useScroll, useMotionValueEvent } from 'motion/react'

import useIsMobile from '@/hooks/useIsMobile'
import { Translation } from '@/types/Content.types'
import { usePageContext } from '@/contexts/PageContext'

import HeaderContext from './HeaderContext'
import { HeaderContextType } from '../Header.types'

const OFFSET_Y = 100

const HeaderProvider = ({
  isHomepage,
  children,
  translations,
}: {
  isHomepage?: boolean
  translations?: Translation[]
  children: React.ReactNode
}) => {
  const isMobile = useIsMobile()
  const { scrollY } = useScroll()

  const [isOpen, setIsOpen] = useState(false)
  const [compressed, setCompressed] = useState(false)

  const { header } = usePageContext()

  // const menuFormatted = HeaderMenuModel(menu)

  let translationsItems = translations
  if (!translationsItems) {
    // TODO: get browser route
    // build languages links and list
    translationsItems = []
  }

  useMotionValueEvent(scrollY, 'change', (latest) => {
    if (isMobile) return

    if (latest > OFFSET_Y) {
      setCompressed(true)
    } else {
      setCompressed(false)
    }
  })

  const value = useMemo(() => {
    const baseValue = {
      compressed,
      isOpen,
      setIsOpen,
      isMobile,
      isHomepage,
      translationsItems,
    }
    if (!header) return baseValue
    const { menu, banner } = header
    return {
      ...baseValue,
      banner,
      menu: menu?.items ?? [],
    }
  }, [
    header,
    compressed,
    isOpen,
    setIsOpen,
    isMobile,
    isHomepage,
    translationsItems,
  ])
  return (
    <HeaderContext.Provider value={value as HeaderContextType}>
      {children}
    </HeaderContext.Provider>
  )
}

export default HeaderProvider
